import React from 'react'
import './AppView.css'

const AppView = props => (
  <div className={`App-view ${props.name}`}>
    {props.children}
  </div>
)

export default AppView


// WEBPACK FOOTER //
// ./src/components/layout/view/AppView.js